export interface BaseSource {
  createdAt: string;
  updatedAt: string;
  id: string;
  title?: string;
}

export class BaseModel<U extends BaseSource> {
  public createdAt: string;
  public id: string;
  public title: string;
  public updatedAt: string;

  constructor(source: U) {
    this.id = source.id;
    this.title = source.title;
    this.createdAt = source.createdAt;
    this.updatedAt = source.updatedAt;
  }
}
